import React from "react";
import { FORM_ELEMENTS_CLASSES } from "../../../../utils/form-builder.types";
import { useFormData } from "../../../../hooks/client/use-form-data";
const firstInputIndex = 0;
const FormBuilderFormInterfaceHidden = ({ item }) => {
  if (!item) return null;
  const { formData } = useFormData();
  const isInputHiddenElement = item.class.includes(FORM_ELEMENTS_CLASSES.HIDDEN);
  const isSubmitMultiple = item.name.includes("[]");
  const defaultValue = formData == null ? void 0 : formData[item.name];
  const newInputValues = isInputHiddenElement && isSubmitMultiple ? Array.isArray(defaultValue) ? defaultValue.filter((_, index) => index !== firstInputIndex) : null : null;
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
    "input",
    {
      type: item.type,
      name: item.name,
      id: item.id,
      className: item.class,
      value: isSubmitMultiple ? defaultValue == null ? void 0 : defaultValue[firstInputIndex] : defaultValue,
      "data-association-type": (item == null ? void 0 : item["data-association-type"]) ? item == null ? void 0 : item["data-association-type"] : null
    }
  ), newInputValues && newInputValues.map((value, index) => {
    const cleanHiddenElementId = item.id.split("_", 2).join("_");
    const newInputId = `${cleanHiddenElementId}_${index + 1}`;
    return /* @__PURE__ */ React.createElement(
      "input",
      {
        id: newInputId,
        key: `${value}_${index + 1}`,
        value,
        name: item.name,
        type: item.type,
        className: item.class
      }
    );
  }));
};
FormBuilderFormInterfaceHidden.displayName = "FormBuilderFormInterfaceHidden";
export default React.memo(FormBuilderFormInterfaceHidden);
